module.exports = __webpack_public_path__ + "fd860b79f4945f3a533c74d6820a0c44.svg";